import { render, staticRenderFns } from "./createtime.vue?vue&type=template&id=5f75320c&"
import script from "./createtime.vue?vue&type=script&lang=js&"
export * from "./createtime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports